var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"member-avatar",style:({ background: _vm.member ? _vm.member.color : '#ccc', width: _vm.size + 'px', height: _vm.size + 'px', fontSize: (_vm.size * 0.42) + 'px' })},[(_vm.member)?[_vm._v(_vm._s(_vm.member.name.slice(0, 1)))]:[_vm._v("?")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }